import { Pipe, PipeTransform } from '@angular/core';

import { NO_VALUE } from '@pipes';
import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateHeatingDeviceStatus',
})
export class TranslateHeatingDeviceStatusPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string | number | undefined): string {
    if (!value) {
      return NO_VALUE;
    }
    value = value.toString();

    if (this.customTranslationsService.HEATING_DEVICE_STATUS[value]) {
      return this.translateService.instant(
        this.customTranslationsService.HEATING_DEVICE_STATUS[value] ?? value
      );
    }

    return value;
  }
}
